import {SttState} from "@/features/call2text/SttState";

export function isRecognitionDone(state: SttState):boolean {
    return state === SttState.DONE
}
